<template>
  <div class="profile-layout type-profile">
    <main-navbar></main-navbar>
    <div
      class="wrapper"
      :class="[{ 'nav-open': $sidebar.showSidebar }]"
      @click="closeArea"
    >
      <notifications></notifications>
      <side-bar
        :mini="true"
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
      >
        <template slot="links">
          <div class="profiles">
            <sidebar-item
              v-if="!isAcademic"
              class="sidebar-item-plus"
              :link="{
                name: 'Prospect Search',
                icon: 'source',
                path: '/prospect-search',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Industry Financial',
                icon: 'card_travel',
                path: '/new-profile/industry-financial-profile',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Industry Market',
                icon: 'leaderboard',
                path: '/new-profile/industry-market-profile',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Companies',
                icon: 'business',
                path: '/company-search',
              }"
            ></sidebar-item>
            <div v-if="!isAcademic" class="disable">
              <sidebar-item
                :link="{
                  name: 'Market',
                  icon: 'insights',
                  path: '/',
                }"
              ></sidebar-item>
              <sidebar-item
                :link="{
                  name: 'Franchise',
                  icon: 'store',
                  path: '/',
                }"
              ></sidebar-item>
            </div>
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Valuation Multiple',
                icon: 'addchart',
                path: '/valuation-multiple',
              }"
            ></sidebar-item>
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Financial Report',
                icon: 'text_snippet',
                path: '/create-report-format/financial',
              }"
            ></sidebar-item>
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Market Report',
                icon: 'newspaper',
                path: '/create-report-format/market',
              }"
            ></sidebar-item>
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Valuation Report',
                icon: 'request_quote',
                path: '/create-report-format/valuation',
              }"
            ></sidebar-item>
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Company Report',
                icon: 'summarize',
                path: '/create-report-format/company',
              }"
            ></sidebar-item>
          </div>
          <div v-if="!isAcademic" class="section_wpr">My Data</div>
          <div class="profiles border-0">
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Prospect List',
                icon: 'format_list_bulleted',
                path: '/my-prospect-lists',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Profiles',
                icon: 'folder_open',
                path: '/my-profiles',
              }"
            ></sidebar-item>
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Reports',
                icon: 'description',
                path: '/my-reports',
              }"
            ></sidebar-item>
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Data',
                icon: 'dns',
                path: '/my-data',
              }"
            ></sidebar-item>
          </div>
        </template>
      </side-bar>
      <app-side-bar
        :mini="true"
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
      >
        <mobile-menu></mobile-menu>

        <template slot="links">
          <div class="search_panel lft-prfl-bar">
            <ul class="filter_list prfl-cmpany-bar">
              <sidebar-item
                :link="{
                  name: 'About',
                  icon: 'help',
                  path: `/companies/${profileInfoId}/company-about-the-data`,
                  type: 'product',
                }"
              >
              </sidebar-item>

              <sidebar-item
                :class="profileInfo || !loading ? '' : 'disabled-item'"
                :link="{
                  name: 'Company Details',
                  icon: 'info',
                  path: `/companies/${profileInfoId}/profile`,
                  type: 'product',
                }"
              >
              </sidebar-item>

              <sidebar-item
                :class="profileInfo || !loading ? '' : 'disabled-item'"
                :link="{
                  name: 'Bizminer Insights',
                  icon: 'developer_board',
                  path: `/companies/${profileInfoId}/finanical-insights`,
                  type: 'product',
                }"
              >
              </sidebar-item>

              <sidebar-item
                :class="profileInfo || !loading ? '' : 'disabled-item'"
                :link="{
                  name: 'Industry COVID-19',
                  icon: 'local_hospital',
                  path: `/companies/${profileInfoId}/month-to-month-employment-sales`,
                  type: 'product',
                }"
              >
              </sidebar-item>
            </ul>
          </div>
        </template>
      </app-side-bar>
      <div class="main-panel">
        <div :class="{ content: !$route.meta.hideContent }">
          <div v-if="!isAboutRoute" class="content">
            <PulseLoader
              :loading="loading"
              :class="{ hide: !loading }"
              quote="Action is the foundational key to all success"
              author="Pablo Picasso"
              profession="Spanish Painter"
              img="picasso.jpg"
            ></PulseLoader>
          </div>
          <zoom-center-transition :duration="200" mode="out-in">
            <div class="row">
              <router-view
                :headerData="headerData"
                v-if="!loading || isAboutRoute"
              />
              <!--<PulseLoader :loading="loading" :class="{ hide: !loading }" class="pulse"></PulseLoader>-->
            </div>
          </zoom-center-transition>
        </div>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

function initSidebar() {
  document.body.classList.toggle("sidebar-mini");
}

import MainNavbar from "./MainNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import { PulseLoader } from "@/components";
import Vuex, { mapActions } from "vuex";
import axios from "axios";

export default {
  components: {
    MainNavbar,
    ContentFooter,
    MobileMenu,
    PulseLoader,
  },
  data() {
    return {
      sidebarBackgroundColor: "grey",
      sidebarBackground: "green",
      sidebarBackgroundImage:
        process.env.VUE_APP_BASE_URL + "/img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + "/img/laravel-vue.svg",
      roles: [],
      loading: true,
      isAboutRoute: false,
      headerData: [],
    };
  },
  methods: {
    ...mapActions({
      updatePullTime: "tracking/updatePullTime",
    }),
    showExtendArea: function(e) {
      e.stopPropagation();
      let el = e.currentTarget;
      let pos = el.offsetTop;
      let all_el = document.querySelectorAll(".filter_list li");
      let dropDown = document.querySelectorAll(".dropdown_area");
      let scrl = document.querySelector(".search_panel").scrollTop;
      let elem = el.querySelector(".dropdown_area");
      let screen = window.innerHeight - 75;
      elem.style.top = "auto";
      if (el.classList.contains("show")) {
        el.classList.remove("show");
      } else {
        all_el.forEach(function(x) {
          x.classList.remove("show");
        });
        el.classList.add("show");
      }
      dropDown.forEach(function(x) {
        x.addEventListener("click", function(e) {
          e.stopPropagation();
        });
      });
      if (screen < elem.offsetHeight + pos) {
        elem.style.bottom = 10 + "px";
        elem.style.top = "auto";
      } else {
        elem.style.top = pos + 75 - scrl + "px";
        elem.style.bottom = "auto";
      }

      var favSelects = document.querySelectorAll(".favourite_list");
      [].forEach.call(favSelects, function(el) {
        el.classList.remove("open");
      });
    },
    closeArea: function() {
      let all_el = document.querySelectorAll(".filter_list li");
      all_el.forEach(function(x) {
        x.classList.remove("show");
      });
    },
    getCompanyProfile: async function() {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );
      this.loading = true;
      this.$store.commit("SET_PROFILE_INFO_ID", this.id);

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + "/user/profile/company",
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.id,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/profile/company" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          if (res.data.error == false) {
            const { data, release_display } = res.data;
            this.$store.commit("SET_RELEASE_DATE", new Date(release_display));
            this.$store.commit("SET_PROFILE_INFO", data);
            this.loading = false;
          } else {
            if (res.data.errorCode === "report_wrong_user") {
              this.$router.push({ name: "Search" });
            }
          }
        })
        .finally(() => {
          this.updatePullTime({
            isFinishedDate: true,
            productId: this.id,
          });
        });
    },
    checkRoute() {
      if (this.$route.name === "CompanyAboutTheData") return true;

      return false;
    },
    getHeaderData() {
      axios
        .get(process.env.VUE_APP_API_BASE_URL + "/info/productHeader", {
          params: {
            product_id: this.$route.params.id,
          },
        })
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/productHeader" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.headerData = res.data;
        });
    },
  },
  mounted() {
    this.getHeaderData();
    this.isAboutRoute = this.checkRoute();
  },
  async created() {
    await this.getCompanyProfile();
  },

  computed: {
    ...Vuex.mapState({
      me: (state) => state.profile.me,
      isAcademic: (state) => state.user.user_type.academic ?? null,
    }),
    id() {
      return this.$route.params.id;
    },
    profileInfo() {
      return this.$store.getters.profileInfo;
    },
    profileInfoId() {
      return this.$store.getters.profileInfoId;
    },
  },
  watch: {
    me: {
      handler: function(val) {
        this.roles = val.roles.map((r) => r.name);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.disabled-item {
  opacity: 0.5;
  pointer-events: none;
}

.sidbar {
  .sidbar-box {
    .md-list-item-container:hover {
      background-color: #3e4345 !important;
    }

    .md-list-item-content {
      justify-content: center;
      flex-direction: column-reverse;
      &:hover,
      &:active {
        background-color: #3e4345 !important;
        .md-icon {
          color: #3b7ef1 !important;
          svg {
            fill: #3b7ef1 !important;
          }
        }
      }

      .md-icon {
        color: white !important;
        margin: 0 !important;
        svg {
          fill: white !important;
          &:hover,
          &:active {
            fill: #3b7ef1 !important;
          }
        }
      }
      p {
        color: white;
        font-size: 12px;
        text-align: center;
        line-height: 1.5;
      }
    }
  }
}
</style>
